import { User } from '../types';

export const isUserDeleted = (user?: Partial<User>): boolean => {
    if (!user?.status) {
        return false; // Don't assume a user is deleted if the status is not defined
    }
    return user.status.toLowerCase() === 'deleted';
};
